<ng-container>
  <bepatient-question-title-v3
    [title]="question.label"
    [constraints]="question.constraints"
    [color]="color"
    [errors]="question.errors"
    [css]="question.css"
    [type]="question.controlType"
    (resetEvent)="resetHandle($event)"
    [key]="question.key"
    [value]="value"
    [dirty]="dirty"
    [formGroup]="formGroup"
    [hasCondition]="question.hasCondition"
  >
  </bepatient-question-title-v3>

  <div
    class="ionic-range"
    [ngClass]="resetMode ? 'reset' : ''"
    [formGroup]="formGroup"
  >
    <ion-range
      mode="ios"
      [pin]="showSliderValue"
      [ticks]="question.showTicks"
      [snaps]="question.showTicks"
      [step]="question.step"
      [min]="question.min"
      [max]="question.max"
      [value]="value"
      (ionKnobMoveEnd)="onSlideChangeEnd($event)"
      (ionFocus)="onFocus()"
      [value]="sliderValue"
    ></ion-range>
  </div>
  <!-- Input number range label (start and end label) -->
  <ion-row class="boundary-label" *ngIf="question.min || question.max">
    <ion-col>
      <ion-label
        [ngStyle]="{ 'font-weight': floorReached ? 'bold' : 'normal' }"
        >{{
          question.startLabel ? question.startLabel : question.min
        }}</ion-label
      >
    </ion-col>
    <ion-col class="ion-text-end">
      <ion-label
        [ngStyle]="{ 'font-weight': maxReached ? 'bold' : 'normal' }"
        >{{ question.endLabel ? question.endLabel : question.max }}</ion-label
      >
    </ion-col>
  </ion-row>
</ng-container>
